/* globals build, ga */
const trackingIds ={
    tellody: 'UA-87779767-2'
};
const fetchGA = function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
    };
    i[r].l = 1 * new Date();
    a = s.createElement(o);
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
};

const id = trackingIds[ build.deployment];
if (id) {
    fetchGA(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    ga('create', id, 'auto');
    ga('send', 'pageview');
}